module.exports = __webpack_public_path__ + "static/img/genre_ttl.abf258c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/genre_ttl.svg
// module id = DaNe
// module chunks = 0